import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Card, Col, Form, Row, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { BASE_URL } from "../../services/Api";
import { authHeader } from "../../services/auth-header";

const EditBrand = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [brandname, setbrandname] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchBrandData = async () => {
      try {
        const response = await axios.get(BASE_URL + "brand/findById/" + id, {
          headers: authHeader(),
        });
        setbrandname(response.data.brandname);
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to fetch brand data. Please try again.',
        });
      }
    };

    fetchBrandData();
  }, [id]);

  const validateForm = () => {
    if (!brandname) {
      Swal.fire({
        icon: 'warning',
        title: 'Incomplete Form',
        text: 'Please enter a brand name.',
      });
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    setIsLoading(true);

    const brandData = {
      brandname,
    };

    try {
      await axios.put(`${BASE_URL}brand/update/${id}`, brandData, {
        headers: authHeader(),
      });
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Brand details updated successfully!',
      });
      navigate("/brandindex/1");
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response.data,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>UPDATE BRAND</h6>
          <Link to="/brandindex/1">
            <button className="button-70">BACK</button>
          </Link>
        </Card.Header>
        <Card.Body>
          <Form>
            <Row>
              <Col md={6}>
                <Form.Group controlId="formbrandname">
                  <Form.Label>Brand Name</Form.Label>
                  <Form.Control
                    placeholder="Enter brand name"
                    value={brandname}
                    onChange={(e) => setbrandname(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <button className="button-70" type="button" onClick={handleSubmit} disabled={isLoading}>
              {isLoading ? <Spinner animation="border" size="sm" /> : 'UPDATE'}
            </button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default EditBrand;